<template>
  <ZDialog :show="show" modal-size="modal-lg">
    <template #header>
      <div class="row w-100">
        <div class="col-md-11">
          <h4 class="modal-title">ADAS Inspection # {{ adasInspection }}</h4>
        </div>
        <div class="col-md-1">
          <a href="#" class="custom-close" @click.prevent="$emit('close')"><i class="fa fa-times"></i></a>
        </div>
      </div>
    </template>
    <template #body>
      <div v-if="loading" class="text-muted py-3">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Loading the inspection results…
      </div>
      <div v-else-if="errorMessage" class="alert alert-warning py-2 mb-0">{{ errorMessage }}</div>
      <div v-else-if="info">
        <div class="custom-vehicle mb-3">
          <strong>{{ vehicleTitle }}</strong>
          <span class="text-muted ms-2">VIN {{ vehicle.vin }}</span>
          <span v-if="info.ronumber" class="text-muted ms-2">RO {{ info.ronumber }}</span>
        </div>

        <div class="fw-bold mb-1">Required Calibrations ({{ required.length }})</div>
        <div v-if="!required.length" class="text-muted small mb-3">ADAS Map found no calibrations required for this vehicle.</div>
        <table v-else class="table table-sm table-bordered custom-results mb-3">
          <thead>
            <tr><th>Calibration</th><th>System</th><th>Category</th><th>Location</th></tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in required" :key="`req-${i}`">
              <td>{{ r.calibration }}</td><td>{{ r.system }}</td><td>{{ r.category }}</td><td>{{ r.location }}</td>
            </tr>
          </tbody>
        </table>

        <div v-if="notRequired.length">
          <div class="fw-bold mb-1">Other Identified Systems ({{ notRequired.length }})</div>
          <table class="table table-sm table-bordered custom-results mb-0">
            <thead>
              <tr><th>System</th><th>Category</th><th>Status</th></tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in notRequired" :key="`nr-${i}`">
                <td>{{ r.system || r.calibration }}</td><td>{{ r.category }}</td>
                <td>{{ r.isNotEquipped ? 'Not Equipped' : 'Not Required' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <template #footer>
      <button class="btn btn-secondary btn-sm" @click="$emit('close')">Close</button>
    </template>
  </ZDialog>
</template>
<script>
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import { api } from '@/plugins/api'
// Read-only view of what ADAS Map identified for an inspection, fetched from its owning environment.
export default {
  name: 'DialogInspectionResult',
  components: { ZDialog },
  props: {
    show: { type: Boolean, default: false },
    source: { type: String, default: null },
    adasInspection: { type: [Number, String], default: null }
  },
  emits: ['close'],
  data() {
    return { loading: false, errorMessage: '', info: null }
  },
  computed: {
    vehicle() {
      return (this.info && this.info.vehicle) || {}
    },
    vehicleTitle() {
      return [this.vehicle.year, this.vehicle.make, this.vehicle.model].filter((p) => p).join(' ')
    },
    results() {
      return (this.info && Array.isArray(this.info.results)) ? this.info.results : []
    },
    // Same split as the dashboard inspection view (#675).
    required() {
      return this.results.filter((r) => r.isRequired === true && !r.isNotEquipped)
    },
    notRequired() {
      return this.results.filter((r) => r.isRequired !== true || r.isNotEquipped)
    }
  },
  watch: {
    show(value) {
      if (value) this.load()
    }
  },
  mounted() {
    if (this.show) this.load()
  },
  methods: {
    async load() {
      this.info = null
      this.errorMessage = ''
      if (!this.source || !this.adasInspection) {
        this.errorMessage = 'The inspection was created, but its results could not be located.'
        return
      }
      this.loading = true
      try {
        const resp = await api.get(`dashboard/clientInspection?adasInspection=${encodeURIComponent(this.adasInspection)}&source=${encodeURIComponent(this.source)}`)
        if (!resp || resp.error) {
          this.errorMessage = (resp && resp.error) || 'ADAS Map did not return the inspection results.'
        } else {
          this.info = resp
        }
      } catch (e) {
        this.errorMessage = 'ADAS Map did not return the inspection results.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-close {
  color: #6c757d;
  font-size: 1.1rem;
}
.custom-results {
  font-size: 0.85rem;
}
</style>
